import { render, staticRenderFns } from "./nicknameTips.vue?vue&type=template&id=57d41279"
import script from "./nicknameTips.vue?vue&type=script&lang=js"
export * from "./nicknameTips.vue?vue&type=script&lang=js"
import style0 from "./nicknameTips.vue?vue&type=style&index=0&id=57d41279&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports